import {
  ACTIVITY_ADD_NEW,
  ACTIVITY_ADD_NEW_SUCCESS,
  ACTIVITY_ADD_NEW_ERROR,
  ACTIVITY_DELETE,
  ACTIVITY_DELETE_ERROR,
  ACTIVITY_DELETE_SUCCESS,
  ACTIVITY_EDIT,
  ACTIVITY_EDIT_ERROR,
  ACTIVITY_EDIT_SUCCESS,
  ACTIVITY_GET_BY_ID,
  ACTIVITY_GET_BY_ID_ERROR,
  ACTIVITY_GET_BY_ID_SUCCESS,
  ACTIVITY_GET_LIST,
  ACTIVITY_GET_LIST_ERROR,
  ACTIVITY_GET_LIST_SUCCESS,
  ACTIVITY_ADD_NEW_REQUEST,
} from '../actions';

const initialState = {
  activities: [],
  activity: null,
  loading: false,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ACTIVITY_GET_BY_ID:
      return {
        ...state,
        loading: false,
        error: null,
        editSuccess: false,
      };
    case ACTIVITY_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: true,
        activity: payload,
      };

    case ACTIVITY_ADD_NEW_REQUEST:
      return {
        ...state,
        addSuccess: false,
      };
    case ACTIVITY_GET_LIST:
      return {
        ...state,
        error: null,
        loading: false,
      };
    case ACTIVITY_GET_LIST_SUCCESS:
      return {
        ...state,
        activities: payload,
        loading: true,
      };
    case ACTIVITY_ADD_NEW:
      return {
        ...state,
        loading: false,
        error: null,
        addSuccess: false,
      };

    case ACTIVITY_ADD_NEW_SUCCESS:
      return {
        ...state,
        loading: true,
        activity: payload,
        activities: state.activities.concat(payload),
        addSuccess: true,
      };

    case ACTIVITY_EDIT:
      return {
        ...state,
        loading: false,
        error: null,
        editSuccess: false,
      };
    case ACTIVITY_EDIT_SUCCESS:
      return {
        ...state,
        activities: state.activities.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        activity: payload,
        error: null,
        editSuccess: true,
      };
    case ACTIVITY_DELETE:
      return {
        ...state,
        loading: false,
        error: null,
        deleteSuccess: false,
      };
    case ACTIVITY_DELETE_SUCCESS:
      return {
        ...state,
        loading: true,
        activities: state.activities.filter(c => c.id !== payload),
        deleteSuccess: true,
      };

    case ACTIVITY_DELETE_ERROR:
    case ACTIVITY_ADD_NEW_ERROR:
    case ACTIVITY_EDIT_ERROR:
    case ACTIVITY_GET_BY_ID_ERROR:
    case ACTIVITY_GET_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
